<div class="current-question-container" id="current-question-container">
    <div #topChat id="topChat">                </div>
    <div class="consultant" id="consultant">
        <!-- <div id="consultantPhoto" [ngStyle]="{'background-image': 'url(' + consultant.photoURL + ')'}"></div> -->
        <img class="consultantPhoto" src="{{imageRootFolder}}consultant.png" id="consultantPhoto">
        <div class="spacingPhotoAndText"></div>
        <div [ngClass]="isRTL?'questionTextRTL':'questionText'"  id="currentQuestionDiv" >
                <!-- <div *ngIf="!isLoading" @fadeSlideInOut >{{currentQuestion ? currentQuestion.questionText: ''}}</div> -->
                <div *ngIf="!isLoading && currentQuestion != undefined" @fadeSlideInOut [innerHTML]="currentQuestion.questionText" ></div>
                <!-- <div *ngIf="isLoading" @fadeSlideInOut>

                <div class="wave">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                </div>

            </div> -->
        </div>
    </div>
    
    <div class="current-question-consultantName"><span class="timeSpacer">&nbsp;</span>{{"discoveryProcess.consultantName" | translate}}</div>
    <div class="userResponse"  id="userResponseDiv">
        <app-chat-response-options [isLoading]=isLoading [userResponseNumber]=userResponseNumber [responseOptions]="currentQuestion ? possibleResponses : undefined" (responsesPopulatedEvent)="responsesPopulatedEvent()" (responseSelectedEvent)=sendQuestionResponse($event)></app-chat-response-options>
        <div class="responseSpace"></div>
        <input type="text" id="endOfChatInput" #bottomChat style="visibility: hidden;"  />
    </div>
    
</div>